import type { ReactNode } from 'react';
import { Column, Row } from '../container/Container';
import { CustomText } from './Texts';

type Props = {
	icon?: ReactNode;
	listItems: Array<string>;
	markerSpacingLeft?: string;
	textStyle?: string;
	textColor?: string;
	gapBetweenIconAndText?: string;
	gapBetweenListItems?: string;
};

const Lists = ({ listItems, gapBetweenListItems }: Props) => {
	return (
		<ul>
			<Column gap={gapBetweenListItems}>
				{listItems.map((item: string) => (
					<li key={item}>{item}</li>
				))}
			</Column>
		</ul>
	);
};

export const BulletList = ({
	listItems,
	markerSpacingLeft,
	gapBetweenListItems,
	textStyle,
}: Props) => {
	return (
		<ul className="list-disc list-inside">
			<Column gap={gapBetweenListItems}>
				{listItems.map((item: string) => (
					<li
						className={`${markerSpacingLeft} ${textStyle}`}
						key={item}
					>
						{item}
					</li>
				))}
			</Column>
		</ul>
	);
};

export const ListWithIcon = ({
	listItems,
	markerSpacingLeft,
	gapBetweenIconAndText,
	icon,
	textStyle,
	gapBetweenListItems,
}: Props) => {
	return (
		<ul>
			<Column gap={gapBetweenListItems}>
				{listItems.map((item: string) => (
					<li className={`${markerSpacingLeft}`} key={item}>
						<Row gap={gapBetweenIconAndText}>
							{icon}{' '}
							<CustomText className={textStyle} text={item} />
						</Row>
					</li>
				))}
			</Column>
		</ul>
	);
};
export default Lists;
